import Swal from 'sweetalert2';

class Alert {

    /**
     * Constructor
     */
    constructor() {
    }

    showAlert(alertSettings) {

        if(alertSettings == null) {
            return;
        }

        Swal.fire({
            icon: alertSettings.icon,
            title: alertSettings.title,
            text: alertSettings.text,
            showConfirmButton: alertSettings.showConfirmButton,
            timer: alertSettings.timer
        })
    }
}

const HdAlert = new Alert();

// Set global
window.hdtrade.HdAlert = HdAlert;